import { InjectionToken } from '@angular/core';

export const MEDIA_BREAKPOINTS_PROVIDER = new InjectionToken<MediaBreakpointsProvider>('Media breakpoints provider');

export type MediaBreakpointsProvider = Record<string, number>;
